/*
 * @Author: huajian
 * @Date: 2023-05-17 11:04:37
 * @LastEditors: yusha
 * @LastEditTime: 2024-03-14 21:55:54
 * @Description:
 */

type env = 'dev' | 'prod' | 'pre';
// eslint-disable-next-line
const m = window.location.host.split('-s.theckb.com');
const n = window.location.host.split('s.theckb.com');

let env = n[0] ? m[0] : 'prod';
if (window.location.port) {
    env = 'dev';
} else if (env !== 'pre' && env !== 'prod') {
    env = 'test';
}

/**
 * 存在cookie的token名称
 */
export const TokenSignCookie: string = env + '_route/token';

export const Config = {
    isLogin: false,
    env: env as env,
    envUrl: n[0] ? `${m[0]}-` : ''
};
